import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../config/ApiUrl";

export const getTenantEmailTemplateList = createAsyncThunk(
  "TenantEmailTemplate/get",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setActivePayload(payload));
      const filteredPayload = Object.fromEntries(
        Object.entries(payload).filter(
          ([, value]) => value !== null && value !== undefined && value !== ""
        )
      );
      const params = new URLSearchParams();
      for (const [key, value] of Object.entries(filteredPayload)) {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            params.append(key, item);
          });
        } else {
          params.append(key, value);
        }
      }
      const queryString = params.toString();
      const { data } = await axios.get(
        `${API_URL.TENANT_EMAIL_TEMPLATE.SLUG}?${queryString}`
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editTenantEmailTemplate = createAsyncThunk(
  "TenantEmailTemplate/put",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${API_URL.TENANT_EMAIL_TEMPLATE.SAVE}`,
        payload
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const resetTenantEmailTemplate = createAsyncThunk(
  "TenantEmailTemplate/reset",
  async (emailTemplateId, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.post(
        `${API_URL.TENANT_EMAIL_TEMPLATE.RESET}/${emailTemplateId}`
      );
      dispatch(getTenantEmailTemplateDetails(emailTemplateId));
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const getTenantEmailTemplateDetails = createAsyncThunk(
  "TenantEmailTemplateDetail/get",
  async (emailTemplateId, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${API_URL.TENANT_EMAIL_TEMPLATE.DETAIL}/${emailTemplateId}`
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const tenantEmailTemplate = createSlice({
  name: "tenantEmailTemplate",
  initialState: {
    isLoading: false,
    current_values: null,
    active_payload: null,
    tenant_email_template_list: [],
    tenant_email_template_details: {},
    total_records: 0,
  },
  reducers: {
    setCurrentValues(state, action) {
      state.current_values = action.payload;
    },
    setActivePayload(state, action) {
      state.active_payload = action.payload;
    },
    resetCurrentValue(state) {
      state.current_values = null;
      state.tenant_email_template_list = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTenantEmailTemplateList.fulfilled, (state, action) => {
        state.tenant_email_template_list = action.payload.data;
        state.total_records = action.payload.data.totalRecords || 0;
      })
      .addCase(getTenantEmailTemplateDetails.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getTenantEmailTemplateDetails.fulfilled, (state, action) => {
        state.tenant_email_template_details = action.payload;
        state.isLoading = false;
      })
      .addCase(getTenantEmailTemplateDetails.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

export const { setCurrentValues, setActivePayload, resetCurrentValue } =
  tenantEmailTemplate.actions;
export default tenantEmailTemplate.reducer;
